import * as React from 'react';
import classnames from 'classnames';

export const CookieCategory: React.FC<{
    baseClassName?: string;
    header: string;
    description: string;
    disabled?: boolean;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
}> = ({ baseClassName, header, description, disabled, checked, onChange }) => {
    const checkboxRef = React.useRef<HTMLInputElement>(null);
    const [updates, setUpdates] = React.useState(0);

    return (
        <div className={`${baseClassName}__cookie-types`}>
            <div className={`${baseClassName}__cookie-types-left`}>
                <div className={`${baseClassName}__cookie-types-header`}>
                    {header}
                </div>
                <div className={`${baseClassName}__cookie-types-description`}>
                    {description}
                </div>
            </div>
            <div className={`${baseClassName}__cookie-types-right`}>
                <label
                    className={classnames(`${baseClassName}__cookie-types-checkbox`, {
                        checked: checked === undefined ? checkboxRef.current?.checked : checked, disabled
                    })}
                    data-u={updates}
                >
                    <input
                        type='checkbox'
                        disabled={disabled}
                        checked={checked}
                        onChange={(e) => {
                            onChange?.(e.target.checked);
                            setUpdates(updates + 1);
                        }}
                        ref={checkboxRef}
                    />
                    <span className={`${baseClassName}__cookie-types-checkbox-indicator`} />
                </label>
            </div>
        </div>
    );
};
